import { defineStore } from 'pinia'
import { ref } from 'vue'
import { emptyCoordinatorQuestionnaire } from '@/helpers/stores/documents'

import type { TODO } from '@/types'

export const useNextEditionCoordinatorQuestionnaireStore = defineStore(
  'nextEditionCoordinatorQuestionnaire',
  () => {
    const coordinatorQuestionnaire = ref({
      nextEditionInclusionRecommendation: null,
      reasonForAbsenceOfRecommendation: null,
      ...emptyCoordinatorQuestionnaire()
    })

    const clearCoordinatorQuestionnaire = () => {
      coordinatorQuestionnaire.value = {
        nextEditionInclusionRecommendation: null,
        reasonForAbsenceOfRecommendation: null,
        ...emptyCoordinatorQuestionnaire()
      }
    }

    const setCoordinatorQuestionnaire = (fields: TODO) => {
      if (!fields) return
      coordinatorQuestionnaire.value = {
        ...coordinatorQuestionnaire.value,
        ...fields
      }
    }

    return {
      coordinatorQuestionnaire,
      clearCoordinatorQuestionnaire,
      setCoordinatorQuestionnaire
    }
  }
)
